import DEFAULT from '@/config/premadeConfigs'
import { PartnerConfig, CopyFunction } from '@/types/partnerConfig'

const { FOOTERLINKS, LOGOS, USA } = DEFAULT
const { CHECK_SYMPTOMS, PRESCRIPTION, CONTENT } = USA
const { WELCOME, REGISTRATION, SUMMARY } = CONTENT

const partnerName = 'Silver Summit'
const planName = 'Silver Summit Health Plan'

const silverSummit: PartnerConfig = {
  branding: {
    logo: [LOGOS.BABYLON],
  },
  config: {
    ...USA.CONFIG,
    id: 'silver-summit-healthplan-centene-nv',
    productConfigAppName: 'silver-summit-healthplan-centene-nv',
    name: partnerName,
    codes: {
      membership: 'SSHP',
    },
    partnerUrlSlug: 'silver-summit',
  },
  content: {
    'en-US': {
      steps: [
        {
          ...WELCOME.enUS,
          copy: (WELCOME.enUS.copy as CopyFunction)(planName),
          productFeatures: [
            CHECK_SYMPTOMS.enUS,
            {
              icon: 'PeopleMedicalSpecialist',
              title:
                'Book a video appointment to talk to a doctor 24 hours a day 7 days a week',
            },
            PRESCRIPTION.enUS,
          ],
        },
        REGISTRATION.enUS,
        SUMMARY.enUS,
      ],
      footerLinks: FOOTERLINKS.USA,
    },
    'es-US': {
      steps: [
        {
          ...WELCOME.esUS,
          copy: (WELCOME.esUS.copy as CopyFunction)(planName),
          productFeatures: [
            CHECK_SYMPTOMS.esUS,
            {
              icon: 'PeopleMedicalSpecialist',
              title:
                'Pida una cita por videollamada para hablar con un médico las 24 horas del día, los 7 días de la semana',
            },
            PRESCRIPTION.esUS,
          ],
        },
        REGISTRATION.esUS,
        SUMMARY.esUS,
      ],
      footerLinks: FOOTERLINKS.USA,
    },
  },
}

const silverSummitWithDnaV2Design: PartnerConfig = {
  ...silverSummit,
  config: {
    ...silverSummit.config,
    useDnaV2Design: true,
  },
}

export default [silverSummit, silverSummitWithDnaV2Design]
